(() => {
  const initialize = (shell) => {
    if (shell.dataset.scrollHeaderReady === 'true') return;

    shell.dataset.scrollHeaderReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frameRequested = false;

    const update = () => {
      const styles = window.getComputedStyle(shell);
      const collapseDistance = Number.parseFloat(styles.getPropertyValue('--site-header-collapse-distance')) || 1;
      const expandedHeight = Number.parseFloat(styles.getPropertyValue('--site-header-expanded-height')) || 154;
      const compactHeight = Number.parseFloat(styles.getPropertyValue('--site-header-compact-height')) || 58;
      const expandedLogoHeight = Number.parseFloat(styles.getPropertyValue('--site-header-expanded-logo-height')) || 32;
      const compactLogoHeight = Number.parseFloat(styles.getPropertyValue('--site-header-compact-logo-height')) || 18;
      const rawProgress = Math.min(Math.max(window.scrollY / collapseDistance, 0), 1);
      const progress = reducedMotion.matches && rawProgress > 0 ? 1 : rawProgress;
      const headerHeight = expandedHeight - ((expandedHeight - compactHeight) * progress);
      const logoHeight = expandedLogoHeight - ((expandedLogoHeight - compactLogoHeight) * progress);

      shell.style.setProperty('--site-header-current-height', `${headerHeight}px`);
      shell.style.setProperty('--site-header-current-logo-height', `${logoHeight}px`);
      shell.classList.toggle('is-compact', progress >= 1);
      frameRequested = false;
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    reducedMotion.addEventListener('change', requestUpdate);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-site-header-shell]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
